import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

import { getClient } from "services";

import { isSignedIn } from "seneca-common/features/user/state";

import { FETCH_LEAD_QUERY_KEY } from "../consts";

export default function useFetchLead() {
  const isUserSignedIn = useSelector(isSignedIn);

  return useQuery({
    queryKey: [FETCH_LEAD_QUERY_KEY],
    queryFn: () => getClient("tutoringService").fetchMyContact(),
    enabled: isUserSignedIn
  });
}
